import { PortalLayout } from '../components/PortalLayout';
import { VUDownloadsTab } from './VUDownloadsTab';

export function VUDownloadsPage() {
  return (
    <PortalLayout currentPage="vu-downloads">
      <div className="flex-1 overflow-auto">
        <VUDownloadsTab />
      </div>
    </PortalLayout>
  );
}
